import { Helmet } from 'react-helmet-async';
import { useMediaQuery } from '@mui/material';
// components
import { TicketView } from '../../../components/dashboard/tickets/ticket';
import MobileTicketView from '../../../components/dashboard/tickets/ticket/mobile/MobileTicketView';

// ----------------------------------------------------------------------

export default function Ticket() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <>
      <Helmet>
        <title>Ticket | Platform Solutions</title>
      </Helmet>

      {isMobile ? <MobileTicketView /> : <TicketView />}
    </>
  );
}
